export interface IUsers {
  userOne: string;
}
export interface IAuth {
  signup: string;
}
export class Images {
  public static readonly bannerLogo: string = './assets/images/logo/login.png';
  public static readonly mainLogo: string = './assets/images/logo/Sns-logo.svg';
  // Mark only: Sns-logo.svg cropped to its 32×32 symbol, for layouts that set the name as text
  public static readonly brandMark: string = './assets/images/logo/sns-mark.svg';

  public static readonly auth: IAuth = {
    signup: './assets/images/authpage/signup.jpg',
  };

  public static readonly users: IUsers = {
    userOne: './assets/images/authpage/profile-image.jpg',
  };
}
